<template>
    <div>
        <loader v-if="isloading"></loader>
        <v-card shaped class="mx-sm-4 my-sm-4 pa-4">
            <v-row>
                <v-col cols="12">
                    <v-toolbar
                        flat
                        color="#1d2735"
                        dark
                        style="border-radius: 5px"
                    >
                        <v-icon class="white--text" style="font-size: 45px"
                            >mdi-account-supervisor-circle</v-icon
                        >
                        <v-toolbar-title>
                            <h3>
                                {{
                                    $route.query.id != null ? "Editar" : "Crear"
                                }}
                                {{
                                    this.$route.meta.rol == 1 ||
                                    $route.query.rol == 1
                                        ? "potencial"
                                        : "cliente"
                                }}
                                {{
                                    $route.query.id != null
                                        ? "N°" + $route.query.id
                                        : ""
                                }}
                            </h3></v-toolbar-title
                        >
                    </v-toolbar>
                    <div display></div>

                    <v-tabs :scrollable="false" v-model="tab">
                        <v-tab>Datos</v-tab>
                        <v-tab-item>
                            <v-row justify="end">
                                <v-tooltip right style="margin-bottom: 5px">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            fab
                                            dense
                                            :to="listpath"
                                            :loading="isloading"
                                            :disabled="isloading"
                                            color="blue"
                                            class="mt-4 mx-3"
                                            v-bind="attrs"
                                            v-on="on"
                                        >
                                            <v-icon class="white--text"
                                                >mdi-arrow-left-bold-outline</v-icon
                                            >
                                        </v-btn>
                                    </template>
                                    <span>Volver</span>
                                </v-tooltip>
                            </v-row>
                            <v-form ref="form" id="form" class="mt-3">
                                <DatosClientes
                                    ref="formDatosClientes"
                                    :agentes="agentes"
                                    v-model="cliente"
                                >
                                    <template v-slot:datos_personales>
                                        <v-col cols="12" md="4" lg="3">
                                            <v-autocomplete
                                                dense
                                                :readonly="
                                                    (rol == 4 || rol == 5) &
                                                    (cliente.id != null)
                                                "
                                                outlined
                                                v-model="cliente.conocido"
                                                :items="conocido"
                                                item-text="name"
                                                item-value="id"
                                                label="¿Cómo nos ha conocido?"
                                            >
                                            </v-autocomplete>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-textarea
                                                rows="3"
                                                auto-grow
                                                outlined
                                                :label="'Observaciones'"
                                                v-model="cliente.observaciones"
                                            >
                                            </v-textarea>
                                        </v-col>
                                    </template>
                                </DatosClientes>
                            </v-form>
                        </v-tab-item>

                        <template v-if="$route.query.id != null">
                            <v-tab>Archivos</v-tab>
                            <v-tab-item>
                                <listaArchivos
                                    v-on:delete_archivo="deleteArchivo"
                                    :items="cliente.archivo"
                                    :extra_headers="[
                                        {
                                            text: 'Presupuesto',
                                            align: 'left',
                                            value: 'id_presupuesto',
                                        },
                                    ]"
                                    @subir_file="subirArchivo"
                                    @subir_file_64="subirArchivo64"
                                ></listaArchivos>
                            </v-tab-item>
                        </template>

                        <v-tab>Ubicación</v-tab>
                        <v-tab-item>
                            <v-row justify="center">
                                <v-col cols="10" md="6">
                                    <h4>Ubicación</h4>
                                </v-col>
                            </v-row>
                            <template v-if="cliente.latitud">
                                <v-row justify="center">
                                    <v-col cols="10" md="6">
                                        <v-text-field
                                            outlined
                                            readonly
                                            v-model="cliente.latitud"
                                            label="Latitud"
                                        >
                                        </v-text-field>
                                    </v-col>
                                </v-row>

                                <v-row justify="center">
                                    <v-col cols="10" md="6">
                                        <v-text-field
                                            outlined
                                            readonly
                                            v-model="cliente.longitud"
                                            label="Longitud"
                                        >
                                        </v-text-field>
                                    </v-col>
                                </v-row>
                            </template>
                            <template v-else>
                                <v-row justify="center">
                                    <v-col cols="10" md="6">
                                        <v-text-field
                                            outlined
                                            readonly
                                            v-model="cliente.direccion.lat"
                                            label="Latitud"
                                        >
                                        </v-text-field>
                                    </v-col>
                                </v-row>

                                <v-row justify="center">
                                    <v-col cols="10" md="6">
                                        <v-text-field
                                            outlined
                                            readonly
                                            v-model="cliente.direccion.lon"
                                            label="Longitud"
                                        >
                                        </v-text-field>
                                    </v-col>
                                </v-row>
                            </template>
                            <v-row justify="center">
                                <v-col cols="10" md="6">
                                    <v-btn
                                        @click="navigate"
                                        :disabled="isloading"
                                        color="primary"
                                        class="white--text"
                                        >Abrir en Google Maps</v-btn
                                    >
                                </v-col>
                            </v-row>
                            <v-row justify="center">
                                <v-col cols="10" md="6">
                                    <v-btn
                                        @click="getLocation"
                                        :disabled="isloading"
                                        color="primary"
                                        class="white--text"
                                        >Conseguir ubicación actual</v-btn
                                    >
                                </v-col>
                            </v-row>
                        </v-tab-item>

                        <template v-if="$route.query.id != null">
                            <v-tab>Presupuestos</v-tab>
                            <v-tab-item v-if="$route.query.id != null">
                                <tab-presupuestos
                                    :presupuestos="cliente.presupuestos"
                                ></tab-presupuestos>
                            </v-tab-item>

                            <v-tab>Obras</v-tab>
                            <v-tab-item>
                                <tab-ordenes
                                    :ordenes="cliente.ordenes"
                                    :id-cliente="cliente.id"
                                ></tab-ordenes>
                            </v-tab-item>

                            <v-tab>Facturas</v-tab>
                            <v-tab-item>
                                <tab-facturas
                                    :facturas="cliente.facturas"
                                    @abono-guardado="getcliente(cliente.id)"
                                ></tab-facturas>
                            </v-tab-item>

                            <v-tab>Seguimiento</v-tab>
                            <v-tab-item>
                                <tab-seguimiento
                                    :id="$route.query.id"
                                ></tab-seguimiento>
                            </v-tab-item>

                            <v-tab>Historial</v-tab>
                            <v-tab-item>
                                <historial-estado-cliente
                                    :id="cliente.id"
                                ></historial-estado-cliente>
                            </v-tab-item>
                        </template>
                    </v-tabs>

                    <v-row style="margin-top: 2rem">
                        <v-col cols="12">
                            <router-link :to="listpath">
                                <v-btn color="red" class="white--text mr-2">
                                    Cancelar
                                </v-btn>
                            </router-link>
                            <v-btn
                                v-if="!cliente.id"
                                @click="savecliente"
                                :disabled="isloading"
                                color="success"
                                class="white--text mr-2"
                                >Guardar</v-btn
                            >

                            <v-btn
                                v-if="cliente.id"
                                @click="updatecliente"
                                :disabled="isloading"
                                color="success"
                                class="white--text mr-2"
                                >Actualizar</v-btn
                            >
                            <router-link
                                :to="`guardar-presupuesto-${
                                    this.$route.meta.rol == 1
                                        ? 'potencial'
                                        : 'cliente'
                                }?cliente=${cliente.id}`"
                            >
                                <v-btn
                                    v-if="cliente.id"
                                    :disabled="isloading"
                                    color="primary"
                                    class="white--text mr-2"
                                    >Generar presupuesto</v-btn
                                >
                            </router-link>
                            <router-link
                                :to="`guardar-peticion?cliente=${cliente.id}&incidencia=1`"
                            >
                                <v-btn
                                    v-if="cliente.id"
                                    :disabled="isloading"
                                    color="primary"
                                    class="white--text mr-2"
                                    >Generar incidencia</v-btn
                                >
                            </router-link>
                            <router-link
                                :to="`guardar-peticion?cliente=${cliente.id}&incidencia=0`"
                            >
                                <v-btn
                                    v-if="cliente.id != null"
                                    :disabled="isloading"
                                    color="primary"
                                    class="white--text mr-2"
                                    >Aviso nuevo presupuesto</v-btn
                                >
                            </router-link>
                            <v-btn
                                v-if="cliente.id"
                                @click="dialog_delete = true"
                                :disabled="isloading"
                                color="red"
                                class="white--text"
                                >Eliminar</v-btn
                            >
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-card>

        <DialogMail
            v-model="dialog_mail"
            :productos="productos"
            :id_cliente="cliente.id"
            :id_producto="cliente.interes"
        ></DialogMail>

        <OrdenTrabajoDialogVue
            :id_cliente="$route.query.id"
            v-model="dialog_orden"
        ></OrdenTrabajoDialogVue>

        <DeleteDialog
            v-model="dialog_delete"
            @delete="deletecliente"
        ></DeleteDialog>
    </div>
</template>

<script>
import Dibujar from "../../presupuesto/componentes/Dibujar.vue";
import listaArchivos from "../../../components/general/listaArchivos.vue";
import HistorialEstadoCliente from "./HistorialEstadoCliente.vue";
import TabSeguimiento from "./TabSeguimiento.vue";
import TabPresupuestos from "./TabPresupuestos.vue";
import TabFacturas from "./TabFacturas.vue";
import TabOrdenes from "./TabOrdenes.vue";
import OrdenTrabajoDialogVue from "./OrdenTrabajoDialog.vue";
import DialogMail from "./DialogMail.vue";
import DatosClientes from "./DatosClientes.vue";
import DeleteDialog from "../../../components/general/dialogs/DeleteDialog.vue";

export default {
    data() {
        return {
            emailRules: [
                (v) => !!v || "El campo es requerido",
                (v) =>
                    !v ||
                    /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
                    "El e-mail debe ser válido",
            ],
            required_val: [(v) => !!v || "El campo es requerido"],

            dialog_delete: false,
            dialog_mail: false,
            dialog_orden: false,
            dialog: false,
            delete_dialog: false,

            tab: 0,
            rol: null,
            panel: [0],
            menu: false,

            cliente: {
                misma_direccion: 1,
                rol: this.$route.meta.rol,
                id: null,
                cif: null,
                id_estado_potencial: 1,
                direccion: {
                    id: null,
                    direccion: "",
                    codigo_postal: "",
                    id_provincia: 0,
                    ciudad: "",
                },
                direccion_instalacion: {
                    id: null,
                    direccion: "",
                    codigo_postal: "",
                    id_provincia: 0,
                    ciudad: "",
                },
                productos: [],
                id_grupo: null,
                razon_social: "",
                nombre_comercial: "",
                grupo: false,
                grupos: [],
                metodos_pago: [],
                observaciones: "",
                contacto_adicional: "",
                latitud: null,
                longitud: null,
                fecha_alta: new Date(
                    Date.now() - new Date().getTimezoneOffset() * 60000
                ).toISOString(),
                id_estado: 1,
                agentes: [],
                contactos: [],
                id_tipologia: -1,
                id_sector1: 0,
                id_sector2: 0,
                conocido: null,
                interes: null,
                cuenta: "",
            },
            id_provincia: 0,

            estados_potencial: [],
            metodos_pago: [],
            grupos: [],
            tiposCliente: [],
            conocido: [],
            productos: [],
            tipologias: [],
            sectores1: [],
            sectores2: [],

            //cruds dinamicos
            estados: [],
            estado: {
                id: null,
                nombre: null,
            },

            sector1: { id: null, nombre: null, tipo: 1 },
            sector2: { id: null, nombre: null, tipo: 2 },
            tiposDirecciones: [],

            //cruds multiples
            agentes: [],
            agente: { id: null, nombre: null },
            agenteSelected: { id: null, nombre: null },
            tipoContactos: ["Comercial", "Facturación"],
            contacto: {
                id: null,
                tipo: "Comercial",
                nombre: "",
                telefono: "",
                email: "",
            },

            /*nueva: 0,
            tipologia: {
                id: null,
                nombre: null,
            },
            producto: {
                id: null,
                nombre: null,
            },
            index: -1,*/
        };
    },
    watch: {
        tab(val) {
            //console.log(this.tab);
        },
        "cliente.grupo": function (val) {
            if (this.cliente.grupo) {
                this.cliente.id_grupo = null;
            }
        },
        menu(val) {
            val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
        },
    },
    created() {
        //this.getProductosNoFilter();
        this.rol = localStorage.getItem("role");
        //this.getProductosInteres();
        this.getAgentes();
        this.getSectores();
        this.getTipologias();
        this.getEstados();

        this.loadQueryData();
        if (this.$route.query.id) {
            if (this.$route.query.tab == "seguimiento") {
                this.tab = 6;
            } else {
                this.tab = parseInt(this.$route.query.tab);
            }
            this.getcliente(this.$route.query.id);
        }
        this.getClientesGrupos();
        this.getConocidos();
        //this.getEstadosPotencial();
    },
    methods: {
        loadQueryData() {
            if (this.$route.query.rs) {
                this.cliente.razon_social = this.$route.query.rs;
            }
            if (this.$route.query.nombre) {
                this.cliente.nombre_comercial = this.$route.query.nombre;
            }
            if (this.$route.query.cif) {
                this.cliente.cif = this.$route.query.cif;
            }
        },

        // Datos del cliente
        getcliente(cliente_id) {
            axios.get(`api/getcliente/${cliente_id}`).then(
                (res) => {
                    this.cliente = res.data;
                    this.cliente.cuenta = res.data.cuenta_contable.numero;

                    this.id_provincia = res.data.id_provincia;

                    this.cliente.fecha_alta = res.data.fecha_alta;
                    if (this.cliente.direccion == null) {
                        this.cliente.direccion = {
                            id: null,
                            direccion: "",
                            codigo_postal: "",
                            id_provincia: 0,
                            ciudad: "",
                        };
                        //console.log(this.cliente);
                    }
                    if (this.cliente.direccion_instalacion == null) {
                        this.cliente.direccion_instalacion = {
                            id: null,
                            direccion: "",
                            codigo_postal: "",
                            id_provincia: 0,
                            ciudad: "",
                        };
                    }
                },
                (res) => {}
            );
        },
        savecliente() {
            if (!this.$refs.form.validate()) {
                return;
            }
            /*if ((this.cliente.productos.length == 0) & (this.rol != 5)) {
                this.$toast.error(
                    "Debe agregar por lo menos un producto de interes"
                );
                return;
            }*/

            axios
                .post("api/save-cliente", this.cliente)
                .then((res) => {
                    //this.$router.push(this.listpath);
                    this.cliente.id = res.data.id;
                    this.$toast.sucs("Cliente guardado con éxito");
                })
                .catch((error) => {
                    console.log(error);
                    //console.log(error.response.status);

                    if (error.response?.data?.mensaje != null) {
                        this.$custom_error(error.response.data.mensaje);
                    } else {
                        this.$custom_error("Algo salió mal");
                    }
                });
        },
        updatecliente() {
            if (!this.$refs.form.validate()) {
                return;
            }

            axios
                .post("api/update-cliente", this.cliente)
                .then((res) => {
                    //this.$router.push(this.listpath);
                    this.$toast.sucs("Cliente guardado con éxito");
                })
                .catch((error) => {
                    //console.log(error);
                    if (error.response?.data?.mensaje != null) {
                        this.$custom_error(error.response.data.mensaje);
                    } else {
                        this.$custom_error("Algo salió mal");
                    }
                });
        },
        deletecliente() {
            axios.post("api/delete-cliente", { id: this.cliente.id }).then(
                (res) => {
                    this.$router.push(this.listpath);
                },
                (res) => {}
            );
        },

        // Metodos generales
        getAgentes() {
            axios.get(`api/get-agentes`).then(
                (res) => {
                    this.agentes = res.data.Agentes;
                },
                (res) => {}
            );
        },
        getSectores() {
            axios.get(`api/get-cliente-sectores`).then(
                (res) => {
                    let data = res.data;
                    this.sectores1 = data.sector1;
                    this.sectores2 = data.sector2;
                },
                (res) => {}
            );
        },
        getTipologias() {
            axios.get(`api/get-cliente-tipologias`).then(
                (res) => {
                    let data = res.data;
                    this.tipologias = data.tipologias;
                },
                (res) => {}
            );
        },
        getEstados() {
            axios.get(`api/get-cliente-estados`).then(
                (res) => {
                    let data = res.data;
                    this.estados = data.estados;
                },
                (res) => {}
            );
        },
        getClientesGrupos() {
            axios.get(`api/get-cliente-grupos`).then(
                (res) => {
                    this.grupos = res.data.Clientes;
                },
                (res) => {}
            );
        },
        getConocidos() {
            axios.get(`api/get-cliente-conocido`).then(
                (res) => {
                    this.conocido = res.data;
                },
                (res) => {}
            );
        },

        // Acciones de archivos del cliente
        subirArchivo(archivo) {
            archivo.append("id", this.cliente.id);
            axios.post(`api/save-archivo-cliente`, archivo).then((res) => {
                this.cliente.archivo = res.data;
            });
        },
        deleteArchivo(archivo) {
            axios.get(`api/deletearchivo/${archivo.id}`).then(
                (res) => {
                    this.cliente.archivo = res.data;
                },
                (res) => {
                    this.$toast.error("Error al eliminar el archivo");
                }
            );
        },
        subirArchivo64(data) {
            //console.log(extension);
            let me = this;
            axios
                .post(`api/save-archivo64-cliente`, {
                    id: this.cliente.id,
                    archivo: data.data,
                    nombre: data.nombre,
                    extension: data.extension,
                })
                .then((res) => {
                    me.cliente.archivo = res.data;
                    this.$toast.sucs("Archivo guardado con éxito");
                    clear();
                });
        },

        // Acciones de geolocalización del cliente
        success(pos) {
            const crd = pos.coords;
            this.cliente.longitud = crd.longitude;
            this.cliente.latitud = crd.latitude;
        },
        error(err) {
            console.warn(`ERROR(${err.code}): ${err.message}`);
        },
        getLocation() {
            navigator.geolocation.getCurrentPosition(this.success, this.error, {
                enableHighAccuracy: true,
                timeout: 5000,
                maximumAge: 0,
            });
        },
        navigate() {
            let lat = this.cliente.latitud;
            let lng = this.cliente.longitud;
            if (lat == null) {
                lat = this.cliente.direccion.lat;
                lng = this.cliente.direccion.lon;
            }
            // If it's an iPhone..
            if (
                navigator.platform.indexOf("iPhone") !== -1 ||
                navigator.platform.indexOf("iPod") !== -1
            ) {
                function iOSversion() {
                    if (/iP(hone|od|ad)/.test(navigator.platform)) {
                        // supports iOS 2.0 and later
                        var v = navigator.appVersion.match(
                            /OS (\d+)_(\d+)_?(\d+)?/
                        );
                        return [
                            parseInt(v[1], 10),
                            parseInt(v[2], 10),
                            parseInt(v[3] || 0, 10),
                        ];
                    }
                }
                var ver = iOSversion() || [0];

                var protocol = "http://";
                if (ver[0] >= 6) {
                    protocol = "maps://";
                }
                window.location =
                    protocol +
                    "maps.apple.com/maps?daddr=" +
                    lat +
                    "," +
                    lng +
                    "&amp;ll=";
            } else {
                window.open(
                    "http://maps.google.com?daddr=" +
                        lat +
                        "," +
                        lng +
                        "&amp;ll="
                );
            }
        },

        // En desuso
        /*Validar() {
            axios
                .post("api/validate-cliente", { id: this.$route.query.id })
                .then((res) => {
                    this.$router.go();
                });
        },
        save(date) {
            this.$refs.menu.save(date);
        },
        formatDate(date) {
            if (!date) return null;

            const [year, month, day] = date.split("-");
            return `${day}/${month}/${year}`;
        },
        getEstadosPotencial() {
            axios.get(`api/get-estados-potencial`).then(
                (res) => {
                    this.estados_potencial = res.data;
                },
                (res) => {}
            );
        },
        getProductosInteres() {
            axios.get(`api/get-productos-interes`).then(
                (res) => {
                    this.productos = res.data;
                },
                (res) => {}
            );
        },
         getProductosNoFilter() {
            axios.get(`api/get-productos-filtered`).then(
                (res) => {
                    this.productos_list = res.data.Productos;
                    //console.log(this.productos);
                },
                (err) => {
                    this.$custom_error("Error consultando los productos");
                }
            );
        },
         deleteProducto(indexo) {
            this.cliente.productos.splice(indexo, 1);
        },
        createProducto() {
            this.cliente.productos.push({
                id: null,
                id_producto: this.producto.id,
                producto: JSON.parse(
                    JSON.stringify(
                        this.productos.find(
                            (element) => this.producto.id == element.id
                        )
                    )
                ),
            });
            //console.log(this.cliente.agentes);
            this.agente = JSON.parse(JSON.stringify(this.agenteSelected));
        },
        //funciones del crud de tipologia
        updatethisTipologia(id) {
            this.cliente.id_tipologia = id;
        },
        updateTipologiaS(index) {
            this.tipologia = this.tipologias[index];
        },
        deleteTipologia(id) {
            axios.post("api/delete-cliente-tipologia", { id: id }).then(
                (res) => {
                    this.getTipologias();
                    this.delete_dialog = false;
                    this.cliente.id_tipologia = null;
                },
                (res) => {}
            );
        },
        createTipologia() {
            axios.post("api/save-cliente-tipologia", this.tipologia).then(
                (res) => {
                    this.getTipologias();
                    this.dialog = false;
                },
                (res) => {}
            );
        },
        updateTipologia() {
            axios.post("api/update-cliente-tipologia", this.tipologia).then(
                (res) => {
                    this.getTipologias();
                    this.dialog = false;
                },
                (res) => {}
            );
        },
        //funciones del crud de sector1
        updatethisSector1(id) {
            this.cliente.id_sector1 = id;
        },
        updatethisSector2(id) {
            this.cliente.id_sector2 = id;
        },
        updateSector1S(index) {
            this.sector1 = this.sectores1[index];
        },
        updateSector2S(index) {
            this.sector2 = this.sectores2[index];
        },
        deleteSector1(id) {
            axios.post("api/delete-cliente-sector", { id: id }).then(
                (res) => {
                    this.getSectores();
                    this.cliente.id_sector1 = null;
                },
                (res) => {}
            );
        },
        deleteSector2(id) {
            axios.post("api/delete-cliente-sector", { id: id }).then(
                (res) => {
                    this.getSectores();
                    this.cliente.id_sector2 = null;
                },
                (res) => {}
            );
        },
        createSector1() {
            this.sector1.tipo = 1;
            axios.post("api/save-cliente-sector", this.sector1).then(
                (res) => {
                    this.getSectores();
                    this.dialog = false;
                },
                (res) => {}
            );
        },
        createSector2() {
            this.sector2.tipo = 2;
            axios.post("api/save-cliente-sector", this.sector2).then(
                (res) => {
                    this.getSectores();
                    this.dialog = false;
                },
                (res) => {}
            );
        },
        updateSector1() {
            axios.post("api/update-cliente-sector", this.sector1).then(
                (res) => {
                    this.getSectores();
                    this.dialog = false;
                },
                (res) => {}
            );
        },
        updateSector2() {
            axios.post("api/update-cliente-sector", this.sector2).then(
                (res) => {
                    this.getSectores();
                    this.dialog = false;
                },
                (res) => {}
            );
        },
        updateEstadoS(index) {
            this.estado = this.estados[index];
        },
        deleteEstado(id) {
            axios.post("api/delete-cliente-estado", { id: id }).then(
                (res) => {
                    this.getEstados();
                    this.delete_dialog = false;
                    this.cliente.id_estado = null;
                },
                (res) => {}
            );
        },
        //funciones del Crud de estado
        updatethisEstado(id) {
            this.cliente.id_estado = id;
        },
        createEstado() {
            axios.post("api/save-cliente-estado", this.estado).then(
                (res) => {
                    this.getEstados();
                    this.dialog = false;
                },
                (res) => {}
            );
        },
        updateEstado() {
            //console.log(this.estado);
            axios.post("api/update-cliente-estado", this.estado).then(
                (res) => {
                    this.getEstados();
                    this.dialog = false;
                },
                (res) => {}
            );
        },*/
    },
    filters: {},

    computed: {
        listpath: function () {
            return `lista-${
                this.$route.meta.rol == 1 ? "potenciales" : "clientes"
            }`;
        },
        isloading() {
            return this.$store.getters.getloading;
        },
        provincias() {
            return this.$store.getters.getprovincias;
        },
    },
    components: {
        listaArchivos,
        TabSeguimiento,
        HistorialEstadoCliente,
        Dibujar,
        TabPresupuestos,
        TabFacturas,
        OrdenTrabajoDialogVue,
        DialogMail,
        DatosClientes,
        TabOrdenes,
        DeleteDialog,
    },
};
</script>
<style>
.rowtwo {
    display: flex;
    flex-direction: row;
}
</style>
